/* eslint-disable @typescript-eslint/no-explicit-any */
import * as Types from '@whitewater-guide/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RemoveGaugeMutationVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;

export type RemoveGaugeMutation = {
  __typename?: 'Mutation';
  removeGauge?: string | null | undefined;
};

export const RemoveGaugeDocument = gql`
  mutation removeGauge($id: ID!) {
    removeGauge(id: $id)
  }
`;
export type RemoveGaugeMutationFn = Apollo.MutationFunction<
  RemoveGaugeMutation,
  RemoveGaugeMutationVariables
>;

/**
 * __useRemoveGaugeMutation__
 *
 * To run a mutation, you first call `useRemoveGaugeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveGaugeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeGaugeMutation, { data, loading, error }] = useRemoveGaugeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveGaugeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveGaugeMutation,
    RemoveGaugeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RemoveGaugeMutation, RemoveGaugeMutationVariables>(
    RemoveGaugeDocument,
    options,
  );
}
export type RemoveGaugeMutationHookResult = ReturnType<
  typeof useRemoveGaugeMutation
>;
export type RemoveGaugeMutationResult =
  Apollo.MutationResult<RemoveGaugeMutation>;
export type RemoveGaugeMutationOptions = Apollo.BaseMutationOptions<
  RemoveGaugeMutation,
  RemoveGaugeMutationVariables
>;
